export default __webpack_public_path__ + "assets/capture-3.8a1ad42b.png";